import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Family History & Genealogy Message Board',
  helmet: 'Message Boards'
});
